import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Location, PopStateEvent } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    public title = 'PhiBor Frontend System';
    private lastPoppedUrl: string;
    private yScrollStack: number[] = [];
    public disableLayoutTheme = true;

    constructor(
        private router: Router,
        private location: Location
    ) {}

    ngOnInit() {
        /* Disable layout theme for data apis */
        this.disableLayoutTheme = !!(this.location.path().indexOf('/data/') !== -1);

        /* "Router Scroll Position Restoration" - Angular 6.0 and earlier
         * https://stackoverflow.com/questions/39601026/angular-2-scroll-to-top-on-route-change */
        this.location.subscribe((ev: PopStateEvent) => {
            this.lastPoppedUrl = ev.url;
        });
        this.router.events.subscribe((ev: any) => {
            if (ev instanceof NavigationStart) {
                if (ev.url !== this.lastPoppedUrl) {
                    this.yScrollStack.push(window.scrollY);
                }
            } else if (ev instanceof NavigationEnd) {
                if (ev.url === this.lastPoppedUrl) {
                    this.lastPoppedUrl = undefined;
                    window.scrollTo(0, this.yScrollStack.pop());
                } else {
                    window.scrollTo(0, 0);
                }
            }
        });
        /* -------------------------------------------------------------------- */
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts